import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Deserialize} from 'cerialize';
import {User} from '../models/user';
import {objectToFormData} from 'object-to-formdata';
import {Logement} from '../models/logement';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  data: any = null;
  baseApiUrl: string = environment.api.baseUrl;

  constructor(private http: HttpClient) {
  }

  public load(): Promise<any> {
    return this.http.get(this.baseApiUrl + 'me').toPromise().then(
      (data) => {
        return this.data = Deserialize(data, User);
      },
      (data) => {
        throw new Error('An unexpected error occurred while data loading : ' + data);
      });
  }

  public save(user: any): Promise<any> {
    return this.http.post(this.baseApiUrl + 'update/me', objectToFormData(user)).toPromise().then(
      (data) => {
        return data;
      },
      (data) => {
        if (data.status === 400) {
          return data.error;
        }
        throw new Error('An unexpected error occurred while data loading : ' + data);
      }
    );
  }

  public addLocataire(user: any): Promise<any> {
    return this.http.post(this.baseApiUrl + 'locataire/add', objectToFormData(user)).toPromise().then(
      (data) => {
        return data;
      },
      (data) => {
        if (data.status === 400) {
          return data.error;
        }
        throw new Error('An unexpected error occurred while data loading : ' + data);
      }
    );
  }

  public isLocataire(logement: Logement): boolean {
    const locataires = logement.locataires.filter((locataire) => {
      return locataire.id === this.data.id && this.data.roles.includes('ROLE_LOCATAIRE');
    });
    return locataires.length > 0;
  }

  public isProprietaire(logement: Logement): boolean {
    if (logement.createur.isConstructeur && logement.statut !== 'LIVRE'){
      return false;
    }

    return logement.currentUserIsProprietaire && (this.data.roles.includes('ROLE_COPROPRIETAIRE') || this.data.roles.includes('ROLE_PROPRIETAIRE'));
  }

  public canVoirMesLocataires(logement: Logement): boolean {
    return this.isProprietaire(logement) && logement.statut === 'LIVRE';
  }

  public canVendreLogement(logement: Logement): boolean {
    return this.isProprietaire(logement) && logement.statut === 'LIVRE';
  }


  public hasRoleProprietaire(logement: Logement): boolean {
    return logement.currentUserIsProprietaire && (this.data.roles.includes('ROLE_COPROPRIETAIRE') || this.data.roles.includes('ROLE_PROPRIETAIRE'));
  }
}
